<template>
  <section class="section" id="credits-panel">
    <b-loading
      :is-full-page="true"
      :active="isLoadingCredits || isLoadingStores"
      :can-cancel="false"
    ></b-loading>

    <credits-title @get-credits="getCredits" @give-credit="openCreditModal" />

    <credits-table
      :credits="creditsReverse"
      @open-credit-details="openCreditDetailsModal"
    />

    <b-modal :active.sync="isCreditModalActive">
      <credit-modal :stores="stores" @get-credits="getCredits" />
    </b-modal>

    <b-modal :active.sync="isCreditDetailsModalActive">
      <credit-details-modal :credit="credit" />
    </b-modal>
  </section>
</template>

<script>
import { common } from "../../mixins/common";
import { mask } from "../../mixins/mask";
import { mapGetters } from "vuex";
import creditsTitle from "./CreditsTitle";
import creditsTable from "./credits-table/CreditsTable";
import creditModal from "./CreditModal";
import creditDetailsModal from "./CreditDetailsModal";

export default {
  mixins: [common, mask],

  components: {
    creditsTitle,
    creditsTable,
    creditModal,
    creditDetailsModal
  },

  data() {
    return {
      isLoadingCredits: false,
      isLoadingStores: false,
      isCreditModalActive: false,
      isCreditDetailsModalActive: false,
      credit: {}
    };
  },

  methods: {
    getCredits() {
      this.isLoadingCredits = true;
      this.$store
        .dispatch("getCredits")
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoadingCredits = false;
        });
    },

    openCreditModal() {
      this.isCreditModalActive = true;
    },

    openCreditDetailsModal(creditId) {
      this.isLoadingCredits = true;
      this.$store
        .dispatch("getCreditDetails", creditId)
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.credit = res.data.payload.credit;
            this.isCreditDetailsModalActive = true;
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoadingCredits = false;
        });
    }
  },

  computed: {
    ...mapGetters(["creditsReverse", "stores"])
  },

  mounted() {
    this.getCredits();
  }
};
</script>

<style scoped>
#credits-panel {
  margin-top: 3rem;
  min-height: 100vh;
  background-color: hsl(0, 0%, 96%);
}
</style>
